module.exports = __webpack_public_path__ + "img/variety_of_siderails.62e32f57.jpg";